import {createWebSocketService} from '../dam/damWebSocketService';
import uamAsyncRequestService from './uamAsyncRequestService';
import UamWebSocketClient from './uamWebSocketClient';
import uamWebSocketResponseService from './uamWebSocketResponseService';

const uamWebSocketService = createWebSocketService({
    servicePrefix: 'uamWebSocketService',
    WebSocketClientClass: UamWebSocketClient,
    responseService: uamWebSocketResponseService,
    asyncRequestService: uamAsyncRequestService,
});

export default uamWebSocketService;
